const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-staff-card'] = {
        c: () => require('partner/modules/ecomm-staff-card/ecomm-staff-card.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-staff-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-staff-card'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-staff-card|ecomm-staff-card'] = {
                c: () => require('partner/modules/ecomm-staff-card/ecomm-staff-card.view.tsx'),
                cn: '__local__-__local__-ecomm-staff-card'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };